import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

export const numberImages = [
  <g>
    <g>
      <StyledRect x="1230.99" y="2348.88" width="151.94" height="151.94"/>
      <path d="M1373.53,2358.88v132.53H1241V2358.88h132.54m10-10H1231v152.53h152.54V2348.88Z"/>
      <path d="M1283.11,2466.22c0-15,4.2-24.15,16.5-37,12.6-13.35,16.2-21.3,16.2-31.05,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="2158.37" y="2196.34" width="151.94" height="151.94"/>
      <path d="M2300.9,2206.34v132.54H2168.37V2206.34H2300.9m10-10H2158.37v152.54H2310.9V2196.34Z"/>
      <path d="M2209.59,2300.48v-8.55h15.6v9.3c0,7.5,3.3,10.35,8.55,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.34-10.8-13.34h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-8,2.85-8,9.75v6.9H2210v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,25.95v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,10.94,12.15,21.59v9.3c0,16.8-8.4,25.95-24.6,25.95S2209.59,2317.28,2209.59,2300.48Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="1574.96" y="1261.78" width="151.94" height="151.94"/>
      <path d="M1717.49,1271.78v132.53H1585V1271.78h132.53m10-10H1575v152.53h152.53V1261.78Z"/>
      <path d="M1627.08,1379.12c0-15,4.2-24.15,16.5-37,12.6-13.35,16.2-21.3,16.2-31,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.59,9.6,24.59,26.4c0,12.45-5.09,23.55-20.39,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.34v15h-47.69Z"/>
    </g>
    <g>
      <StyledRect x="2044.23" y="1663.94" width="151.94" height="151.94"/>
      <path d="M2186.77,1673.94v132.53H2054.23V1673.94h132.54m10-10H2044.23v152.53h152.54V1663.94Z"/>
      <path d="M2095.45,1768.08v-8.55h15.6v9.3c0,7.5,3.3,10.35,8.55,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-7.95,2.85-7.95,9.75v6.9h-15.6v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,26v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,11,12.15,21.6v9.3c0,16.8-8.4,26-24.6,26S2095.45,1784.88,2095.45,1768.08Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="2579.5" y="1868.95" width="151.94" height="151.94"/>
      <path d="M2722,1879v132.53H2589.5V1879H2722m10-10H2579.5v152.53H2732V1869Z"/>
      <path d="M2631.61,1986.29c0-15,4.2-24.15,16.5-37,12.6-13.35,16.2-21.3,16.2-31,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="1727.49" y="2627.46" width="151.94" height="151.94"/>
      <path d="M1870,2637.46V2770H1737.49V2637.46H1870m10-10H1727.49V2780H1880V2627.46Z"/>
      <path d="M1778.71,2731.6v-8.55h15.6v9.3c0,7.5,3.3,10.35,8.55,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-8,2.85-8,9.75v6.9h-15.6v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,26v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,11,12.15,21.6v9.3c0,16.8-8.4,25.95-24.6,25.95S1778.71,2748.4,1778.71,2731.6Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="1732.83" y="1625.54" width="151.94" height="151.94"/>
      <path d="M1875.37,1635.54v132.53H1742.83V1635.54h132.54m10-10H1732.83v152.53h152.54V1625.54Z"/>
      <path d="M1785,1742.88c0-15,4.2-24.15,16.5-37.05,12.6-13.35,16.2-21.3,16.2-31,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25H1785v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15H1785Z"/>
    </g>
    <g>
      <StyledRect x="1917.6" y="2649.64" width="151.94" height="151.94"/>
      <path d="M2060.13,2659.64v132.54H1927.6V2659.64h132.53m10-10H1917.6v152.54h152.53V2649.64Z"/>
      <path d="M1968.82,2753.79v-8.55h15.6v9.3c0,7.49,3.3,10.35,8.55,10.35s8.55-2.56,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-8,2.85-8,9.75v6.9h-15.6V2698c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,26v3.75c0,11.25-3.61,18.15-11.71,21.15v.3c8.85,3.3,12.15,10.95,12.15,21.6v9.29c0,16.8-8.4,26-24.59,26S1968.82,2770.58,1968.82,2753.79Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="2526.52" y="1387" width="151.94" height="151.94"/>
      <path d="M2669.06,1397v132.54H2536.52V1397h132.54m10-10H2526.52v152.54h152.54V1387Z"/>
      <path d="M2578.64,1504.35c0-15,4.2-24.15,16.5-37,12.6-13.35,16.2-21.3,16.2-31,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="1485.62" y="2703.62" width="151.94" height="151.94"/>
      <path d="M1628.16,2713.62v132.53H1495.62V2713.62h132.54m10-10H1485.62v152.53h152.54V2703.62Z"/>
      <path d="M1536.84,2807.76v-8.55h15.6v9.3c0,7.5,3.3,10.35,8.55,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-7.95,2.85-7.95,9.75v6.9h-15.6V2752c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,25.95v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,10.95,12.15,21.6v9.3c0,16.8-8.4,26-24.6,26S1536.84,2824.56,1536.84,2807.76Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="1707.79" y="1118.85" width="151.94" height="151.94"/>
      <path d="M1850.32,1128.85v132.53H1717.79V1128.85h132.53m10-10H1707.79v152.53h152.53V1118.85Z"/>
      <path d="M1759.9,1236.19c0-15,4.2-24.15,16.5-37,12.6-13.35,16.2-21.3,16.2-31.05,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="1389.43" y="2088.93" width="151.94" height="151.94"/>
      <path d="M1532,2098.93v132.53H1399.43V2098.93H1532m10-10H1389.43v152.53H1542V2088.93Z"/>
      <path d="M1440.65,2193.07v-8.55h15.6v9.3c0,7.5,3.3,10.35,8.55,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35H1457v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-8,2.85-8,9.75v6.9h-15.6v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,25.95v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,10.95,12.15,21.6v9.3c0,16.8-8.4,26-24.6,26S1440.65,2209.87,1440.65,2193.07Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="1923.73" y="2000" width="151.94" height="151.94"/>
      <path d="M2066.27,2010v132.53H1933.73V2010h132.54m10-10H1923.73v152.53h152.54V2000Z"/>
      <path d="M1975.85,2117.34c0-15,4.2-24.15,16.5-37.05,12.6-13.35,16.2-21.3,16.2-31.05,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="2000.01" y="1053.77" width="151.94" height="151.94"/>
      <path d="M2142.54,1063.77v132.54H2010V1063.77h132.54m10-10H2000v152.54h152.54V1053.77Z"/>
      <path d="M2051.22,1157.92v-8.55h15.6v9.3c0,7.5,3.3,10.35,8.55,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-7.95,2.85-7.95,9.75v6.9h-15.6v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,26v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,10.95,12.15,21.6v9.3c0,16.8-8.4,26-24.6,26S2051.22,1174.72,2051.22,1157.92Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="2612.6" y="2028.33" width="151.94" height="151.94"/>
      <path d="M2755.14,2038.33v132.54H2622.6V2038.33h132.54m10-10H2612.6v152.54h152.54V2028.33Z"/>
      <path d="M2664.72,2145.67c0-15,4.2-24.15,16.5-37.05,12.6-13.35,16.2-21.3,16.2-31,0-9.44-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.24h-15.6V2077c0-16.79,8.4-26.39,24.6-26.39s24.6,9.6,24.6,26.39c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="2057.04" y="1258.91" width="151.94" height="151.94"/>
      <path d="M2199.57,1268.91v132.54H2067V1268.91h132.53m10-10H2057v152.54h152.53V1258.91Z"/>
      <path d="M2108.25,1363.06v-8.55h15.6v9.3c0,7.49,3.3,10.35,8.55,10.35s8.55-2.56,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.25-10.5s-7.95,2.85-7.95,9.75v6.9h-15.6v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.15,9.15,24.15,25.95v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,11,12.15,21.6v9.3c0,16.79-8.4,25.94-24.6,25.94S2108.25,1379.85,2108.25,1363.06Z"/>
    </g>
  </g>,

  <g>
    <g>
      <StyledRect x="2247.49" y="2525.59" width="151.94" height="151.94"/>
      <path d="M2390,2535.59v132.53H2257.49V2535.59H2390m10-10H2247.49v152.53H2400V2525.59Z"/>
      <path d="M2299.61,2642.93c0-15,4.2-24.15,16.5-37,12.6-13.35,16.2-21.3,16.2-31.05,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.6,9.6,24.6,26.4c0,12.45-5.1,23.55-20.4,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.35v15h-47.7Z"/>
    </g>
    <g>
      <StyledRect x="1615.66" y="1503.09" width="151.94" height="151.94"/>
      <path d="M1758.19,1513.09v132.54H1625.66V1513.09h132.53m10-10H1615.66v152.54h152.53V1503.09Z"/>
      <path d="M1666.88,1607.24v-8.55h15.59v9.3c0,7.49,3.3,10.35,8.55,10.35s8.55-2.56,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.55v-15h6c6.15,0,9.9-2.7,9.9-11.1v-7.65c0-7.5-3.45-10.5-8.24-10.5s-8,2.85-8,9.75v6.9h-15.59v-5.55c0-16.8,8.4-26.1,24.14-26.1s24.15,9.15,24.15,26V1555c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,11,12.15,21.6v9.3c0,16.8-8.4,25.94-24.6,25.94S1666.88,1624,1666.88,1607.24Z"/>
    </g>
  </g>,
 
  <g>
    <g>
      <StyledRect x="2636.54" y="2123.56" width="151.94" height="151.94"/>
      <path d="M2779.07,2133.56V2266.1H2646.54V2133.56h132.53m10-10H2636.54V2276.1h152.53V2123.56Z"/>
      <path d="M2688.66,2240.91c0-15,4.2-24.15,16.5-37,12.59-13.35,16.2-21.3,16.2-31.05,0-9.45-3.3-12-8.55-12s-8.55,2.85-8.55,10.35v11.25h-15.6v-10.2c0-16.8,8.4-26.4,24.6-26.4s24.59,9.6,24.59,26.4c0,12.45-5.1,23.55-20.39,39.75-9.9,10.5-12.45,15.75-12.45,23.1v2.25h31.34v15h-47.69Z"/>
    </g>
    <g>
      <StyledRect x="1190.9" y="1847.46" width="151.94" height="151.94"/>
      <path d="M1333.43,1857.46V1990H1200.9V1857.46h132.53m10-10H1190.9V2000h152.53V1847.46Z"/>
      <path d="M1242.12,1951.61v-8.55h15.6v9.3c0,7.5,3.29,10.35,8.54,10.35s8.55-2.55,8.55-11.85v-8.55c0-9.75-3.3-13.35-10.8-13.35h-5.54v-15h6c6.14,0,9.89-2.7,9.89-11.1v-7.65c0-7.5-3.44-10.5-8.24-10.5s-7.95,2.85-7.95,9.75v6.9h-15.6v-5.55c0-16.8,8.4-26.1,24.15-26.1s24.14,9.15,24.14,26v3.75c0,11.25-3.6,18.15-11.7,21.15v.3c8.85,3.3,12.15,11,12.15,21.6v9.3c0,16.8-8.4,26-24.59,26S1242.12,1968.41,1242.12,1951.61Z"/>
    </g>
  </g>
]

export const TerrestrialNumbers = ({num}) => {
  const index = num-1
  return (
    numberImages[index]
  )
}
